import React from 'react';
import { StyledSpace } from './styled';
import { ISpace } from './types';

export const Space = ({ fullWidth, ...props }: ISpace) => (
  <StyledSpace {...props} $fullWidth={fullWidth} />
);

Space.defaultProps = {
  fullWidth: true,
};

export const VerticalSpace: React.FC<React.PropsWithChildren<ISpace>> = ({
  testId,
  ...props
}) => <Space direction='vertical' size={13} data-testid={testId} {...props} />;

export const FormSpace: React.FC<React.PropsWithChildren<ISpace>> = props => (
  <VerticalSpace size={0} {...props} />
);
